import { type ChatRequest } from '../../services/api/ai';
import { type SuggestedAction } from '../../types/ai';

import { getVisibleSuggestedActionLabel, LANG_TO_SIMULATED_MARKET } from './constants';

type BuildChatRequestArgs = {
  message: string;
  sessionId: string;
  language: string;
  clientRequestId: string;
  conversationHistory: ChatRequest['conversationHistory'];
  image?: ChatRequest['image'];
  suggestedAction?: SuggestedAction;
  structuredSuggestion?: SuggestedAction;
  modelConfig?: string;
  customerId?: string;
};

const buildSuggestionMetadata = (
  suggestedAction: SuggestedAction,
  structuredSuggestion?: SuggestedAction,
) => ({
  actionId: structuredSuggestion?.actionId,
  label:
    getVisibleSuggestedActionLabel(structuredSuggestion) ??
    structuredSuggestion?.label ??
    suggestedAction.label,
  value: structuredSuggestion?.value ?? suggestedAction.value,
  ...(structuredSuggestion?.intentType ? { intentType: structuredSuggestion.intentType } : {}),
  ...(structuredSuggestion?.canonicalAction
    ? { canonicalAction: structuredSuggestion.canonicalAction }
    : {}),
  payload: structuredSuggestion?.payload ?? suggestedAction.payload,
});

export const buildChatRequest = ({
  message,
  sessionId,
  language,
  clientRequestId,
  conversationHistory,
  image,
  suggestedAction,
  structuredSuggestion,
  modelConfig,
  customerId,
}: BuildChatRequestArgs): ChatRequest => {
  const simulatedMarket = LANG_TO_SIMULATED_MARKET[language];

  const metadata: Record<string, unknown> = {
    clientRequestId,
    clientSurface: 'playground',
    language,
    ...(simulatedMarket
      ? {
          siteContext: {
            hostname: simulatedMarket.hostname,
            pathname: '/',
            pageType: 'start',
          },
        }
      : {}),
    ...(modelConfig ? { modelConfig } : {}),
    ...(suggestedAction
      ? { suggestedAction: buildSuggestionMetadata(suggestedAction, structuredSuggestion) }
      : {}),
  };

  return {
    message,
    ...(image ? { image } : {}),
    channel: 'website',
    ...(structuredSuggestion ? { source: 'suggestion', suggestion: structuredSuggestion } : {}),
    metadata,
    conversationHistory,
    cid: customerId,
    sessionId,
    clientCapabilities: ['order_card'],
  };
};
